<mat-form-field subscriptSizing="dynamic">
  <mat-label>{{ labelTranslationKey | translate }}</mat-label>
  <mat-date-range-input [rangePicker]="rangePicker">
    <input matStartDate name="range-start-date" [placeholder]="'COMMON.START_DATE' | translate" [ngModel]="startDate" (ngModelChange)="setStartDate($event)" />
    <input matEndDate name="range-end-date" [placeholder]="'COMMON.END_DATE' | translate" [ngModel]="endDate" (ngModelChange)="setEndDate($event)" />
  </mat-date-range-input>
  @if (hasRange) {
    <button matIconSuffix mat-icon-button (click)="clear()" [matTooltip]="'COMMON.CLEAR' | translate" [attr.aria-label]="'COMMON.CLEAR' | translate">
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
  <mat-date-range-picker #rangePicker></mat-date-range-picker>
</mat-form-field>
